<template>
  <div></div>
</template>

<script>
  export default {
    name: "Index",
    data () {
      return {

      }
    },
    components: {
    },
    mounted () {
      this.$router.push({ name: "Wages" })
    }
  }
</script>